// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__19RFF","inner":"Form_inner__2pmnk","range":"Form_range__Gf4p2","name":"Form_name__2CjWJ","actions":"Form_actions__1xO0w"};